import React from 'react'
import './BusinessFAQ.scss'
import BusinessFAQCard from './BusinessFAQCard/BusinessFAQCard'

const BusinessFAQ = ({data}) => {
  return (
    <div className='businessFAQ_container'>
      <div className="businessFAQ_block">
        {
          data?.map((i)=>
           <BusinessFAQCard key={i.id} title={i.title} subTitle={i.subTitle} img={i.img} link={i.link}/>
          )
        }
      </div>
    </div>
  )
}

export default BusinessFAQ
